import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  CLEAR_MAINTENANCE_PLANNING_ACTIVITY_RESOURCES,
  FLAG_GETTING_MAINTENANCE_PLANNING_ACTIVITY_RESOURCES,
  GET_MAINTENANCE_PLANNING_ACTIVITY_RESOURCES,
} from '../../../actions/types';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_MAINTENANCE_PLANNING_ACTIVITY_RESOURCES:
      return state.setIn(['all', 'loading'], payload);
    case GET_MAINTENANCE_PLANNING_ACTIVITY_RESOURCES:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_MAINTENANCE_PLANNING_ACTIVITY_RESOURCES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    default:
      return state;
  }
};
